export default __webpack_public_path__ + "270072563d074f6bd7cd0f917e328249.png";